import { apiFetch } from './client'

export interface SyncDeviceStat {
  device_id: string
  device_name: string
  device_status: string
  pending: number
  processing: number
  done: number
  failed: number
}

export interface SyncJob {
  id: string
  device_id: string
  device_name: string
  operation: string
  status: 'pending' | 'processing' | 'done' | 'failed'
  attempts: number
  last_error?: string
  payload: Record<string, unknown>
  created_at: string
  processed_at?: string
  next_retry_at?: string
}

export const getSyncStats = () =>
  apiFetch<{ stats: SyncDeviceStat[] }>('/sync/stats')

export const getSyncJobs = (params?: { deviceId?: string; status?: string; limit?: number; offset?: number }) => {
  const qs = new URLSearchParams()
  if (params?.deviceId)          qs.set('deviceId', params.deviceId)
  if (params?.status)            qs.set('status',   params.status)
  if (params?.limit  != null)    qs.set('limit',    String(params.limit))
  if (params?.offset != null)    qs.set('offset',   String(params.offset))
  return apiFetch<{ jobs: SyncJob[]; total: number; limit: number; offset: number }>(
    `/sync/jobs${qs.toString() ? '?' + qs : ''}`,
  )
}

export const triggerSync = () =>
  apiFetch<{ ok: boolean }>('/sync/trigger', { method: 'POST' })

export const retrySync = (params?: { deviceId?: string; jobId?: string }) =>
  apiFetch<{ ok: boolean }>('/sync/retry', {
    method: 'POST',
    body: JSON.stringify(params ?? {}),
  })

export const resyncMemberships = () =>
  apiFetch<{ ok: boolean; queued: number }>('/sync/resync-memberships', { method: 'POST' })
